module.exports = __webpack_public_path__ + "img/congestion-status-dining-hall_odd.f0a7e59c.svg";